export const STATUS_STEPS = [
  { key: "placed", label: "Order Placed" },
  { key: "confirmed", label: "Confirmed" },
  { key: "out_for_delivery", label: "Out for Delivery" },
  { key: "delivered", label: "Delivered" },
];

export const STATUS_LABEL = {
  placed: "Order Placed",
  confirmed: "Confirmed",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export const STATUS_COLOR = {
  placed: "bg-brand-ochre/20 text-brand",
  confirmed: "bg-blue-100 text-blue-800",
  out_for_delivery: "bg-brand-terracotta/20 text-brand-terracotta",
  delivered: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-700",
};
